/**
 * canvas tools
 */

const config = {
  // color1: '#27447d',
  // color2: '#96e897'
  color1: 'black',
  color2: 'white'
}


const drawId = (canvasObj, x, y) => {
  let letter = canvasObj.id;
  let width = 20;
  if (letter.length === 2)
    width += 10;
  let ctx = canvasObj.canvas.getContext('2d');
  ctx.font = "16px monospace";
  ctx.fillStyle = config.color1;
  ctx.fillRect(x - 8, y - 8, width, 20);
  ctx.fillStyle = config.color2;
  ctx.fillText(letter, x - 3, y + 8);
}

const drawCircle = (canvasObj) => {
  // console.groupCollapsed(canvasObj);
  let start, end;
  if (canvasObj.newPositions.length === 0){
    start = canvasObj.positions[0].start;
    end = canvasObj.positions[0].end;
  }
  else {
    start = canvasObj.newPositions[0].start;
    end = canvasObj.newPositions[0].end;
  }
  let ctx = canvasObj.canvas.getContext('2d');
  let radius = Math.sqrt(Math.pow((start[0] - end[0]), 2) + Math.pow((start[1] - end[1]), 2));
  draw(radius);
  let xRel = radius * Math.cos(45);
  let yRel = radius * Math.sin(45);
  drawId(canvasObj, start[0] + xRel, start[1] - yRel)


  function draw(radius)  {
    ctx.clearRect(0, 0, canvasObj.width, canvasObj.height);

    ctx.setLineDash([10, 0]);
    ctx.beginPath();
    ctx.arc(start[0], start[1], radius, 0, Math.PI * 2);
    ctx.strokeStyle = config.color1;
    ctx.lineWidth = 3;
    ctx.stroke();
    
    ctx.setLineDash([10, 10]);
    ctx.beginPath();
    ctx.arc(start[0], start[1], radius, 0, Math.PI * 2);
    ctx.strokeStyle = config.color2;
    ctx.lineWidth = 3;
    ctx.stroke();
  }

}

const drawMultipleLine = async (canvasObj, drawCurrent = false) => {
  let ctx = canvasObj.canvas.getContext('2d');
  ctx.clearRect(0, 0, canvasObj.width, canvasObj.height);
  let posToDraw = canvasObj.newPositions.length !== 0 
    ? canvasObj.newPositions
    : canvasObj.positions;
  let drawing = posToDraw.map(async (line, index) => {
    await _drawLineBlack(canvasObj, line.start, line.end);
    await _drawLineWhite(canvasObj, line.start, line.end);
    if (index === 0 && canvasObj.type === 'line') {
      var middle = [
        line.start[0] + (line.end[0] - line.start[0]) / 2, 
        line.start[1] + (line.end[1] - line.start[1]) / 2
      ];
      drawId(canvasObj, ...middle);
    }
  });
  let last = canvasObj.currentLine;
  if (drawCurrent === true) {
    await _drawLineBlack(canvasObj, last.start, last.end);
    await _drawLineWhite(canvasObj, last.start, last.end);
  }
  await Promise.all(drawing);
  
  let line = posToDraw[0];
  if (canvasObj.type === 'rectangle') {
    var middle = [line.start[0] + (line.end[0] - line.start[0]) / 2, line.start[1]];
  }
  drawId(canvasObj, ...middle);
}

const getMaxRelDist = (e, canvasObj) => {
  let yTop = 10000, xRight = 0, yBottom = 0, xLeft = 10000;
  if (canvasObj.type === 'circle') {
    let {start, end} = canvasObj.positions[0];
    let radius = Math.sqrt(Math.pow((start[0] - end[0]), 2) + Math.pow((start[1] - end[1]), 2))
    yTop = start[1] - radius;
    xRight = start[0] + radius;
    yBottom = start[1] + radius;
    xLeft = start[0] - radius;
  } else {
    canvasObj.positions.forEach((line) => {
      if (yTop > line.start[1]) yTop = line.start[1];
      if (xRight < line.start[0]) xRight = line.start[0];
      if (yBottom < line.start[1]) yBottom = line.start[1];
      if (xLeft > line.start[0]) xLeft = line.start[0];
    });
  }
  return {
    top: yTop - 3, 
    right: e.target.offsetWidth - xRight - 3, 
    bottom: e.target.offsetHeight - yBottom - 3, 
    left: xLeft - 3
  };
}

const _drawLineBlack = async (canvasObj, start, end) => {
  let ctx = canvasObj.canvas.getContext('2d');

  ctx.setLineDash([10, 0]);
  ctx.beginPath();
  ctx.moveTo(start[0], start[1]);
  ctx.lineTo(end[0], end[1]);
  ctx.strokeStyle = config.color1;
  ctx.lineWidth = 3;
  ctx.stroke();
}
const _drawLineWhite = async (canvasObj, start, end) => {
  let ctx = canvasObj.canvas.getContext('2d');

  ctx.setLineDash([10, 10]);
  ctx.beginPath();
  ctx.moveTo(start[0], start[1]);
  ctx.lineTo(end[0], end[1]);
  ctx.strokeStyle = config.color2;
  ctx.lineWidth = 3;
  ctx.stroke();
}


export default {
  drawCircle, drawMultipleLine, drawId, getMaxRelDist
}
// let img = document.querySelector("#canvas-content img");
// img.onload = () => {
  // let imgStyle = getComputedStyle(img);
  // let x = parseInt(imgStyle["width"]);
  // let y = parseInt(imgStyle["height"]);
  
  // new CanvasLine(x, y);
  // new CanvasRectangle(x, y);
  // new CanvasCircle(x, y);
// }
